import { API } from "@/constant/constants"
import { DATA_PAGINATION, SITE_FOR_MAPVIEW } from "@/types"
import axiosClient from "../axiosClient"

export const sitesApi = {
  getSites(interfaceId: number) {
    return axiosClient.get<DATA_PAGINATION<SITE_FOR_MAPVIEW>>(API.OPERATIONS.SITES.DEFAULT.replace(":interfaceId", `${interfaceId}`))
  }
}

export default sitesApi